// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3_pmX","content":"LayoutSettings_content__gSkNh"};